const kierownicaPoPrawej = { t: 'Kierownica po prawej stronie', name: 'kierownica-po-prawej' }
export default kierownicaPoPrawej